export default function React_Syllabus() {
  return (
    <div>
      <h1>React_Syllabus Component</h1>
      <p>This is the React_Syllabus tutorial page.</p>
    </div>
  );
}
